import React, { FC } from 'react';
import { css } from '@emotion/css';
import CalculatorResultItem, {
  CalculatorResultItemProps,
} from 'evcharging/containers/ev-calculator/CalculatorResultItem';

interface CalculatorResultListProps {
  items: CalculatorResultItemProps[];
}

const CalculatorResultList: FC<CalculatorResultListProps> = (props) => {
  const { items } = props;
  return (
    <ul className={styles.root}>
      {items.map((item) => (
        <CalculatorResultItem {...item} key={item.label} />
      ))}
    </ul>
  );
};

const styles = {
  root: css`
    list-style: none;
    border-bottom: 1px solid #ebebeb;
    padding-top: 12px;
  `,
};

export default CalculatorResultList;
